import instance from "./instance";

export const fetchRequestsNotifications = () => {
  return async (dispatch) => {
    try {
      const res = await instance.get("/has_requests_notifications/");
      if (res.data.success) {
        dispatch({
          type: "SET_REQUESTS_NOTIFICATIONS",
          payload: res.data.data,
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
};
